import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import RichText, { RichTextBlocks } from '~/components/Abstracts/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface HeroCategorySimpleDescriptionProps {
  className?: string
  title?: RichTextBlocks
  description?: RichTextBlocks
}

function HeroCategorySimpleDescription({
  className,
  description,
}: HeroCategorySimpleDescriptionProps) {
  const descriptionStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Haffer,
    color: GlobalThemeColors.MineShaft,
  })

  if (!description) return null

  return (
    <div className={cx(css.HeroCategorySimpleDescription, className)}>
      <RichText
        className={cx(css.description, descriptionStyle)}
        ctaPreset={GlobalTextPreset.Cta12Haffer}
        uppercaseLink={false}
        render={description}
      />
    </div>
  )
}

export default HeroCategorySimpleDescription
